export default function (cell, formatterParams, onRendered) {

  const { link, label, newWindow } = cell.getValue();

  const el = document.createElement('a');

  el.href = link;
  el.innerHTML = label;

  if (newWindow) {
    el.target = '_blank';
  }

  el.innerHTML = el.innerHTML.replace(/^(https?:\/\/)?(www\.)?/, '');
  el.innerHTML = el.innerHTML.replace(/\/$/, '');

  return el;
}
